module.exports = __webpack_public_path__ + "img/Liputan-Image-2.1d289409.png";